export const createAccount = `
    mutation createAccount($input: CreateAccountInput!) {
        createAccount(input:$input) {
            id
            name
            email
            accountType
            status
            organizationId
    }
}`;

export const updateAccount = `
    mutation updateAccount($input: UpdateAccountInput!) {
        updateAccount(input:$input){
            id
            sub
            username
            email
            accountType
            accountStatus
            customerId
            created
            updated
        }
}`;


export const suspendAccount = `
    mutation suspendAccount {
        suspendAccount 
}`;
